import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAppDispatch } from "../../app/hooks";
import { getDashboardPath } from "../../config/dashboardRoutes";
import { syncFromStorage } from "../../features/auth/authSlice";
import { authStorage } from "../../features/auth/authStorage";
import { resolveAuthPermissionId, resolveAuthRoleId } from "../../features/auth/authUtils";
import Login from "../../features/auth/Login";
import { tokenHandler } from "../../utils/tokenHandler";

export default function RootRedirect() {
  const dispatch = useAppDispatch();
  const token = tokenHandler.get();
  const storedUser = authStorage.getAuth();
  const isValid = Boolean(token) && tokenHandler.isValid(0);
  const hasUsableSession = isValid && Boolean(storedUser);
  const dashboardPath = hasUsableSession
    ? getDashboardPath(resolveAuthRoleId(storedUser), resolveAuthPermissionId(storedUser))
    : "/dashboard";

  useEffect(() => {
    if (token && !hasUsableSession) {
      tokenHandler.clear();
      dispatch(syncFromStorage());
    }
  }, [dispatch, hasUsableSession, token]);

  return hasUsableSession ? <Navigate to={dashboardPath} replace /> : <Login />;
}
